import script from "./goRinSyo0052.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0052.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0052.vue?vue&type=style&index=0&id=3d4a78bf&lang=scss"

const __exports__ = script;

export default __exports__